module.exports = __webpack_public_path__ + "ca6c3ac409a3d80e42ff400c30c272ce.png";